// import { get } from "lodash";

export default {
  selectBuildPartnerApplications: (state) => state.buildPartnerApplications.applicationsList,
  selectBuildPartnerApplicationDetail: (state) => state.buildPartnerApplications.detail,
};
